
import React from 'react';
import { mdx } from '@mdx-js/react';


export const frontMatter = {
	id: 'integration-options',
	title: 'Data Access and Integration Paths'
};
export const contentTitle = undefined;
export const metadata = {
  "unversionedId": "integration-options",
  "id": "integration-options",
  "isDocsHomePage": false,
  "title": "Data Access and Integration Paths",
  "description": "The first step is to choose the correct access methods. For many applications, Webhooks will be the preferred method. REST or GraphQL are generally preferred for application integration. Redis and SQS are available for unique situations, such as real-time notifications within an application.",
  "source": "@site/docs/integration-options.md",
  "sourceDirName": ".",
  "slug": "/integration-options",
  "permalink": "/docs/integration-options",
  "tags": [],
  "version": "current",
  "frontMatter": {
    "id": "integration-options",
    "title": "Data Access and Integration Paths"
  },
  "sidebar": "docs",
  "previous": {
    "title": "Getting Started",
    "permalink": "/docs/start"
  },
  "next": {
    "title": "Getting a Quote",
    "permalink": "/docs/getting-started/getting-a-quote"
  }
};


/* @jsxRuntime classic */
/* @jsx mdx */

export const toc = [];

const layoutProps = {
  toc
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`The first step is to choose the correct access methods. For many applications, Webhooks will be the preferred method. REST or GraphQL are generally preferred for application integration. Redis and SQS are available for unique situations, such as real-time notifications within an application.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}><a parentName="th" {...{
              "href": "webhooks/select-events"
            }}>{`Webhooks`}</a></th>
          <th parentName="tr" {...{
            "align": null
          }}>{`REST`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`GraphQL`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Redis*`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Amazon SQS*`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Ad-hoc querying`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Immediate notifications`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Programmatic integration`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
      </tbody>
    </table>
    <ul>
      <li parentName="ul">{`Not available publicly`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
